import { signal } from "@angular/core";
import { SchemaPathTree } from "@angular/forms/signals";

export enum EVEstateFeatureType {
    HasLiveableLoft = 1,
    HasCellar = 2,
    Parking = 3,
    Balcony = 4,
    ClimatePassiveHouse = 5,
    BalancedVentilation = 6,
    DistrictHeating = 7,
    Elevator = 8,
    WaterborneHeat = 9,
}

export interface FacilitiesTypeModel {
    facilitiesType: EVEstateFeatureType;
    index: number;
    selected: boolean;
    displayText: string;
}

const defaultFacilitiesTypes: FacilitiesTypeModel[] = [
    {
        facilitiesType: EVEstateFeatureType.Elevator,
        index: 1,
        selected: false,
        displayText: "Heis",
    },
    {
        facilitiesType: EVEstateFeatureType.Balcony,
        index: 2,
        selected: false,
        displayText: "Balkong",
    },
    {
        facilitiesType: EVEstateFeatureType.Parking,
        index: 3,
        selected: false,
        displayText: "Parkering",
    },
];

export interface FacilitiesTypesFilterModel {
    facilitiesTypes: FacilitiesTypeModel[];
    expanded: boolean;
}

export function createFacilitiesTypesModel() {
    return signal<FacilitiesTypesFilterModel>({
        facilitiesTypes: defaultFacilitiesTypes,
        expanded: false,
    });
}

export function buildFacilitiesTypesModel(a: SchemaPathTree<FacilitiesTypesFilterModel>) {}
